export default __webpack_public_path__ + "fbb80e5de3594ffb75e4f118480f8461.png";